import { arrowDownToBracket } from "@simplybusiness/icons";
import { type DOMProps, Icon, Link, Button } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type React from "react";
import type { RefAttributes } from "react";
import { handleDownload } from "./handleDownload";
import type { WithMetadata } from "../../pages";

export type AgentActionsElement = HTMLDivElement;

export interface AgentActionsProps
  extends DOMProps, RefAttributes<AgentActionsElement> {
  newQuoteUrl: string;
  downloadQuoteUrl: string;
  /** Custom class name for setting specific CSS */
  className?: string;
  elementType?: React.ElementType;
}

export const AgentActions = ({
  ref,
  ...props
}: WithMetadata<AgentActionsProps>) => {
  const {
    elementType: Element = "div",
    newQuoteUrl,
    downloadQuoteUrl,
    componentName,
    ...otherProps
  } = props;

  const classes = classNames(
    "mobius",
    "mobius-agent-actions",
    otherProps.className,
  );
  const { variant } = otherProps;

  return (
    <Element
      ref={ref}
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={classes}
    >
      <Link href={newQuoteUrl} className="mobius-agent-actions__link">
        Start New Quote
      </Link>
      <Button
        size="sm"
        className="mobius-agent-actions__button"
        onClick={() => handleDownload(downloadQuoteUrl)}
      >
        <Icon icon={arrowDownToBracket} title="Download icon" />
        Download Quote Proposal
      </Button>
    </Element>
  );
};

AgentActions.displayName = "AgentActions";
